<div class="col-lg-12 mr-pd hpanel b-r-6">
  <div class="tabMenubarPricepage pd-20">
    <div class="tab-container">
      <div class="tab" [ngClass]="{'active': id=='1'}" (click)="activeTab('1')">
        Referrals
      </div>
      <div class="tab" [ngClass]="{'active': id=='2'}" (click)="activeTab('2')">
        Invited Users
      </div>
      <div class="tab" [ngClass]="{'active': id=='3'}" (click)="activeTab('3')">
        FAQ-Referral
      </div>
    </div>
  </div>

  <div infiniteScroll [infiniteScrollDistance]="1" [scrollWindow]="true" [infiniteScrollThrottle]="300"
    (scrolled)="onScrollDown()">
    <div class="panel-body gs-card-bodygs-card-body">
      <!-- <div class="tab-content"> -->


      <!-- </div> -->
      <div class="tab-content">
        <div class="tab-pane" title="Refer A Friend" [ngClass]="{'active': id=='1'}" id={{id}}>

          <div class="referral-card897">
            <div class="header897">
              <h2 class="title897">Refer A Friend</h2>
              <h3 class="subtitle897">Get 5 referral credits, for every qualified person you invite signs up for GigSumo
              </h3>
            </div>

            <div class="info-text897">
              <span class="info-icon897">*</span>
              <span>Only invites sent to business Email ID's will be considered for referral credits.</span>
            </div>

            <div class="info-text897">
              <span class="info-icon897">*</span>
              <span>You will receive the credit once the person you invite, signs up and verifies his business
                email.</span>
            </div>

            <div class="info-text897">
              <span class="info-icon897">*</span>
              <span>You can redeem referral credits to upgrade jobs or candidates, buy interaction and resume view
                credits.</span>
            </div>

            <p class="instruction-text897">To make the most of the platform and to be successful, invite and connect
              with the <span class="main-point897">right people and companies</span>.</p>

            <div class="audience-section897">
              <div class="audience-item897">
                <span class="audience-emphasis897">***</span>
                <span>Recruiters need to invite Bench sales recruiters & Candidates</span>
              </div>
              <div class="audience-item897">
                <span class="audience-emphasis897">***</span>
                <span>Bench sales recruiters need to invite recruiters</span>
              </div>
              <div class="audience-item897">
                <span class="audience-emphasis897">**</span>
                <span>Candidates need to invite recruiters or candidates</span>
              </div>
            </div>

            <hr class="divider897">
            <form [formGroup]="connectionRequest">
              <div class="form-group897">
                <label class="form-label897" for="email">Email</label>
                <div class="email-input-group897">
                  <tag-input class="email-input897" [formControlName]="'email'" name="email" id="email"
                    [addOnPaste]="true" [editable]="true" [placeholder]="'Enter Email Address'"
                    [secondaryPlaceholder]="'Enter Email Address'" [pasteSplitPattern]="splitPattern"
                    [modelAsStrings]="true" [errorMessages]="errorMessages" [validators]="validators"
                    [separatorKeyCodes]="[32, 188, 9, 186]" (onAdd)="referalLimit()" (onRemove)="referalLimit()">
                  </tag-input>
                  <button type="button" class="send-button897" (click)="SendInvite(ValidEmail)">Send
                    Invitation(s)</button>
                </div>
                <p class="hint-text897">Enter the email and hit enter.</p>
                <!-- Error messages container - stacks vertically -->
                <div class="error-messages-container897">
                  <!-- Show "This field is required" only when field is empty (no tags) -->
                  <div *ngIf="connectionRequest.controls.email.errors?.required &&
                              connectionRequest.controls.email.touched &&
                              (!connectionRequest.controls.email.value || connectionRequest.controls.email.value.length === 0)"
                    class="errorMsg">
                    This field is required
                  </div>
                  <div *ngIf="connectionRequest.controls.email.errors?.invalid" class="errorMsg">
                    Number of invites exceeded the limit ({{referrallimit}})
                  </div>
                </div>
              </div>
            </form>

            <!-- <button class="cta-button897">REFER A FRIEND</button> -->
          </div>


          <!-- <div class="modal-body  paddd">
            <div class="row">
              <div class="col-md-12 bder">
                <form [formGroup]="connectionRequest" class="mrgtop">

                  <label for="message">Email</label>

                  <div class="flex">


                    <tag-input class="tag-align mr-100-px" [formControlName]="'email'" name="email" id="email"
                      [addOnPaste]="true" [editable]="true" [placeholder]="'Enter Email Address'"
                      [secondaryPlaceholder]="'Enter Email Address'" [pasteSplitPattern]="splitPattern"
                      [modelAsStrings]="true" [errorMessages]="errorMessages" [validators]="validators"
                      [separatorKeyCodes]="[32, 188, 9, 186]"  (onAdd)="referalLimit()" (onRemove)="referalLimit()">
                    </tag-input>

                    <button type="button" class="btn btn-primary h-30" (click)="SendInvite(ValidEmail)">Send
                      Invitation(s)</button>

                  </div>

                  <small>Enter the email and hit enter.</small>
                  <div *ngIf="connectionRequest.controls.email.errors?.required &&
                              connectionRequest.controls.email.touched &&
                              (!connectionRequest.controls.email.value || connectionRequest.controls.email.value.length === 0)"
                    class="text-danger">
                    <div class="errorMsg">
                      This field is required
                    </div>
                  </div>
                  <div *ngIf="connectionRequest.controls.email.errors?.invalid" class="errorMsg">
                    Number of invites exceeded the limit ({{referrallimit}})
                  </div>
                </form>
              </div>

            </div>

          </div> -->
        </div>


        <div class="tab-pane" [ngClass]="{'active': id=='2'}" id={{id}}>
          <div class="panel-content-159">
            <!-- Invites Table -->

            <div class="card">
              <div *ngIf="loadAPIcall1" class="margin-bottom-20">
                <app-common-skeleton [countforView]="5" [NameOftheScreen]="'widget-counter'"></app-common-skeleton>
              </div>
              <div *ngIf="!loadAPIcall1 && id=='2'">
                <app-plan-card [columns]="5" [cards]="allocationCards"
                  [TOTAL]="allocationCards[0].value"></app-plan-card>
              </div>
            </div>
            <!-- Search and Filter Header -->
            <div class="search-filter-container-712">
              <!-- Search Container -->
              <div class="search-container-384">
                <div class="search-box-217">
                  <input #txt type="text" placeholder="Search by invited email" class="search-input-693 form-control"
                    (input)="keyupdata(txt.value)" [(ngModel)]="searchContent" />
                  <button class="search-button-541 border-radius-left-0">
                    <ng-icon name="tablerSearch"></ng-icon>
                  </button>
                </div>
              </div>
              <!-- Filter Dropdown -->
              <div class="filter-container-892">

                <div class="btn-group unified-btn" dropdown container="body" placement="bottom right">
              
                  <!-- Single combined filter button -->
                  <button type="button" class="btn btn-primary filter-single-btn-892" dropdownToggle data-toggle="dropdown">
              
                    <span>{{ selectedFilterName }}</span>
                    <ng-icon name="tablerFilter"></ng-icon>
              
                  </button>
              
                  <!-- Dropdown -->
                  <ul class="dropdown-menu no-padding dropdown-menu-right" *dropdownMenu role="menu">

                    <li role="menuitem" (click)="filterApi('All')">
                      <a class="dropdown-item" [class.selected]="appliedFilter === 'All'">All</a>
                    </li>

                    <li role="menuitem" (click)="filterApi('PENDING')">
                      <a class="dropdown-item" [class.selected]="appliedFilter === 'PENDING'">Pending Acceptance</a>
                    </li>

                    <li role="menuitem" (click)="filterApi('CANCELLED')">
                      <a class="dropdown-item" [class.selected]="appliedFilter === 'CANCELLED'">Invitation Cancelled</a>
                    </li>

                    <li role="menuitem" (click)="filterApi('COMPLETED')">
                      <a class="dropdown-item" [class.selected]="appliedFilter === 'COMPLETED'">Invite Accepted</a>
                    </li>

                    <li role="menuitem" (click)="filterApi('USERCANCELLED')">
                      <a class="dropdown-item" [class.selected]="appliedFilter === 'USERCANCELLED'">User Cancelled</a>
                    </li>

                  </ul>
              
                </div>
              
              </div>
            </div>

            <div *ngIf="inviteListLoading && inviteRes.userInvites.length==0" class="tab-pane" [ngClass]="{'active': id=='2'}"
              id={{id}}>
            </div>
            <div *ngIf="inviteListLoading &&  id=='3'" class="tab-pane customAccordion" [ngClass]="{'active': id=='3'}"
              id={{id}}>
              <app-common-skeleton [countforView]="5" [NameOftheScreen]="'faq'"></app-common-skeleton>
            </div>
            <app-common-skeleton *ngIf="inviteListLoading && inviteRes.userInvites.length==0" [countforView]="5"
              [NameOftheScreen]="'candidateDetails'"></app-common-skeleton>
            <!-- No Data Message -->
            <div class="no-data-message-315" *ngIf="inviteRes.userInvites.length==0 && !inviteListLoading">
              <app-nodata-found [title]="['No data found!']"></app-nodata-found>
            </div>


            <div *ngIf="inviteRes.userInvites.length > 0">
              <table class="invites-table-198">
                <tbody>
                  <tr>
                    <td class="td-users">Users</td>
                    <td class="td-status">Invite Status</td>
                    <td class="td-status">Email Status</td>
                    <td class="td-remarks">Remarks</td>
                    <td class="td-updated">Last Updated</td>
                    <td class="td-actionas">Actions</td>
                  </tr>
                  <tr class="invite-row-742" *ngFor="let data of inviteRes?.userInvites">
                    <!-- User Avatar Column -->
                    <td class="avatar-cell-512">
                      <!-- User Photo -->
                       <div class="user-container-295">
                         <div class="avatar-container-295" >
                           <img *ngIf="data?.inviteeUser?.photo" class="user-avatar-631" src="{{url+data?.inviteeUser?.photo}}">
                           <!-- For non-COMPLETED users with fullName, show initials -->
                           <div class="initials-avatar-container-427"
                             *ngIf="!data?.inviteeUser?.photo && data.status!='COMPLETED' && data?.inviteeUser?.fullName">
                             <div class="initials-circle-856"
                               [style.background-color]="getColor(data?.inviteeUser?.fullName)">
                               <div class="initials-text-934"
                                 [style.color]="getFullNameTextColor(data?.inviteeUser?.fullName)">
                                 {{ getInitials(data?.inviteeUser?.fullName) }}
                               </div>
                             </div>
                           </div>
                           <!-- Fallback for users without fullName (truly pending/no user data) -->
                           <img *ngIf="!data?.inviteeUser?.photo && data.status!='COMPLETED' && !data?.inviteeUser?.fullName" class="user-avatar-631" [src]="'assets/images/userAvatar.png'" />
                           <div class="initials-avatar-container-427"
                             *ngIf="!data?.inviteeUser?.photo && data.status=='COMPLETED'">
                             <div class="initials-circle-856"
                               [style.background-color]="getColor(data?.inviteeUser?.fullName)">
                               <div class="initials-text-934"
                                 [style.color]="getFullNameTextColor(data?.inviteeUser?.fullName)">
                                 {{ getInitials(data?.inviteeUser?.fullName) }}
                               </div>
                             </div>
                           </div>
                         </div>
                         <!-- Completed User's Name -->
                         <p class="user-name-523" *ngIf="data.status=='COMPLETED'"
                           title="{{data?.inviteeUser?.firstName}} {{data?.inviteeUser?.lastName}}">
                           {{data?.inviteeUser?.firstName}} {{data?.inviteeUser?.lastName}}
                         </p>
                         <!-- Pending/Cancelled User's Email -->
                         <p class="user-email-615" title="{{data.inviteeEmail}}"
                           *ngIf="data.status=='PENDING' || data.status=='CANCELLED' || data.status=='USERCANCELLED' || data.status=='INACTIVE'">
                           {{data.inviteeEmail}}
                         </p>
                       </div>
                      <!-- Default Avatar for Pending Users -->
                      <!-- <div class="avatar-container-295" >
                      </div> -->
                      <!-- Initials Avatar for Completed Status -->
                    </td>

                    <!-- User Info Column -->
                    <!-- <td class="user-info-cell-731">
                    
                    </td> -->

                    <!-- Status Column -->
                    <td class="status-cell-942">
                      <div *ngIf="!canShowRemark(data?.emailStatus); else noneFound">
                        <span class="status-badge-187 pending-413" *ngIf="data.status=='PENDING'">Pending
                          Acceptance</span>
                        <span class="status-badge-187 cancelled-624" *ngIf="data.status=='USERCANCELLED'">User
                          Cancelled</span>
                        <span class="status-badge-187 cancelled-624" *ngIf="data.status=='CANCELLED'">Invitation
                          Cancelled</span>
                        <span class="status-badge-187 completed-535" *ngIf="data.status=='COMPLETED'">Signed up for
                          Gigsumo</span>
                      </div>
                    </td>

                    <!-- Email status Column -->
                    <td class="date-cell-863">
                      <span *ngIf="data.emailStatus;else noneFound" class="email-status-badge-123"
                        [ngClass]="getEmailStatusClass(data.emailStatus)?.class">
                        {{ getEmailStatusClass(data.emailStatus)?.status }}
                      </span>
                    </td>

                    <!-- Remarks Columns -->
                    <td class="user-info-cell-731" title="{{getRemark(data.emailStatus)}}">
                      <span *ngIf="canShowRemark(data.emailStatus); else noneFound">
                        <span>
                          {{getRemark(data.emailStatus)}}
                        </span>
                      </span>
                    </td>
                    <!-- Date Column -->
                    <td class="date-cell-863">
                      <div class="date-text-123">
                        <!-- {{ data.notifiedOn | timezoneDate }} -->
                          <!-- {{data.notifiedOn | date:'MM/dd/yyyy, hh:mm:ss a'}} -->
                          {{ data.notifiedOn | timezoneDate:'MM/dd/yyyy' }}<br>
                          {{ data.notifiedOn | timezoneDate:'hh:mm:ss a' }}
                      </div>
                    </td>

                    <!-- Actions Column -->
                    <td class="actions-cell-374">
                      <div class="actions-content-374">
                        <!-- Credits Awarded Message -->
                        <div class="credits-message-781" *ngIf="data.status=='COMPLETED'">
                          <span class="credits-text-396">5 Credits awarded</span>
                        </div>
                        <div *ngIf="canShowInviteMenu(data)" class="btn-group" dropdown>
                          <button class="more-options-btn-247" dropdownToggle>
                            <img src="assets/icon/icons8-more-96.png" alt="" srcset="">
                          </button>

                          <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu">
                            <ng-container>
                              <li role="menuitem" *ngIf="data.emailStatus != 'PENDING' && data.emailStatus != 'DeliveryDelay'">
                                <a (click)="showpopup(data.inviteeEmail)"> Cancel </a>
                              </li>
                              <li role="menuitem">
                                <a (click)="resendInvitation(data)"> Resend </a>
                              </li>
                            </ng-container>
                          </ul>

                        </div>

                        <!-- Connect Button -->
                        <button type="button" class="btn btn-primary btn-sm action-btn connect-btn"
                          *ngIf="canConnect(data)"
                          (click)="Connect(data.inviteeUser.userId)">
                          <ng-icon name="tablerUserPlus"></ng-icon> Connect
                        </button>

                        <!-- Cancel Request Button -->
                        <button type="button" class="btn btn-warning btn-sm action-btn cancel-btn"
                          *ngIf="canCancelRequest(data)"
                          (click)="cancel(data.inviteeUser.userId)">
                          <ng-icon name="tablerX"></ng-icon> Cancel Request
                        </button>

                        <!-- Send Message Button -->
                        <button type="button" class="btn primary-btn btn-sm message-btn"
                          *ngIf="canMessage(data)"
                          (click)="sendMessage(data?.inviteeUser?.userId)">
                          <ng-icon name="tablerMail"></ng-icon> Message
                        </button>

                        <!-- No action available -->
                        <span class="no-action-374" *ngIf="!hasActions(data)">-</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Loading Skeleton -->
            <div *ngIf="loadAPIcall && inviteRes.userInvites.length>0" [ngClass]="{'active-826': id=='2'}" id={{id}}
              class="tab-pane-473 loading-pane-261">
              <app-common-skeleton [countforView]="2" [NameOftheScreen]="'candidateDetails'"></app-common-skeleton>
            </div>
          </div>
        </div>

        <div *ngIf="!loadAPIcall" class="tab-pane" [ngClass]="{'active': id=='3'}" id={{id}}>
          <div class="panel-body gs-card-bodygs-card-body">
            <h4 class="faq-title">FAQ's Referral</h4>

            <div class="custom-accordion">
              <div class="accordion-item" *ngFor="let data of faqresponse?.faqList; let i = index">
                <div class="accordion-header"
                     [class.active]="activeAccordionIndex === i"
                     (click)="toggleAccordion(i)">
                  <span class="accordion-question">{{data.question}}</span>
                  <ng-icon name="tablerChevronDown" class="accordion-icon" [class.rotated]="activeAccordionIndex === i"></ng-icon>
                </div>
                <div class="accordion-content"
                     [class.expanded]="activeAccordionIndex === i">
                  <div class="accordion-body">
                    <span [innerHTML]="data?.answer"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #ValidEmail>
        <div class="modal-container-782">
          <div class="modal-header-459">
            <div class="header-title-137">Referral Validations</div>
          </div>
          <div class="modal-body-254 custom-modal-body-893">
            <!-- Existing Users Section -->
            <div class="user-section-365" *ngIf="existUser && existUser.length > 0">
              <div class="section-header-782">
                <span class="section-label-493">Already Existing User<span *ngIf="existUser?.length > 1">s</span></span>
              </div>
              <div class="user-list-container-671">
                <div class="user-item-238" *ngFor="let itemexist of existUser">
                  <span class="user-email-914 text-danger-351">{{itemexist}}</span>
                </div>
              </div>
            </div>

            <!-- Already Invited Users Section -->
            <div class="user-section-365" *ngIf="inviteUser && inviteUser.length > 0">
              <div class="section-header-782">
                <span class="section-label-493">Already Invited User<span *ngIf="inviteUser?.length > 1">s</span></span>
              </div>
              <div class="user-list-container-671">
                <div class="user-item-238" *ngFor="let item of inviteUser">
                  <span class="user-email-914 text-danger-351">{{item}}</span>
                </div>
              </div>
            </div>

            <!-- Duplicate Emails Section -->
            <div class="user-section-365" *ngIf="duplicateEmails && duplicateEmails.length > 0">
              <div class="section-header-782">
                <span class="section-label-493">Duplicate Email<span *ngIf="duplicateEmails?.length > 1">s</span></span>
              </div>
              <div class="user-list-container-671">
                <div class="user-item-238" *ngFor="let item of duplicateEmails">
                  <span class="user-email-914 text-danger-351">{{item}}</span>
                </div>
              </div>
            </div>

            <!-- Inactive Users Section -->
            <div class="user-section-365" *ngIf="inactiveUsers && inactiveUsers.length > 0">
              <div class="section-header-782">
                <span class="section-label-493">Inactive User<span *ngIf="inactiveUsers?.length > 1">s</span></span>
              </div>
              <div class="user-list-container-671">
                <div class="user-item-238" *ngFor="let item of inactiveUsers">
                  <span class="user-email-914 text-danger-351">{{item}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer-179">
            <button type="button" class="btn-ok-627 btn-primary" ngbAutofocus (click)="closemodel()">Ok</button>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<div class="col-sm-8 bottom gs-end-of-list" *ngIf="stopScroll && inviteRes?.userInvites?.length > 0">
  <div class="col-sm-12">
    <!-- <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon> -->
    <ng-icon name="tablerCircleCheck"></ng-icon>

  </div>
  <div class="col-sm-12">
    <p class="biase">You've reached the bottom of the page</p>
  </div>
</div>

<ng-template #noneFound>-</ng-template>